import { QueryClient, QueryClientProvider, useQueryClient } from 'react-query';

export { getEventsById } from './api';
export {
    CONSUMER_CARD_DEFAULTS,
    EventCard,
    parseFollowSignalExperimentVariants,
} from './components/EventCard';
export { DEFAULT_DESTINATION_EXPANSIONS } from './constants';
export { useEvents, useEventsById, useInfiniteEvents } from './hooks';
export {
    transformDestinationEvent,
    transformDiscoveryEvent,
} from './transforms';
export { DestinationEvent, DiscoveryEvent, FormattedEvent } from './types';
export { EventClient, EventClientProvider, useEventClient };

// In case the implementation changes down the line,
// export wrappers around the clients.
const EventClient = QueryClient;
const EventClientProvider = QueryClientProvider;
const useEventClient = useQueryClient;
